/* tslint:disable */
 
export class TransformationDto {

  /**
   * The field full normalized.
   */
  field: string;
  type: 0 | 1 | 2 | 3 | 4 | 5;

  /**
   * The value associated with the transformation.
   */
  value?: any;
}
